module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAxIiBoZWlnaHQ9IjE4OSIgdmlld0JveD0iMCAwIDMwMSAxODkiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbC1ydWxlPSJub256ZXJvIiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSIjMDA1MjkzIiBkPSJNLjUuNzVoMzAwdjE4Ny41SC41eiIvPjxwYXRoIGZpbGw9IiNGRUNCMDAiIGQ9Ik05NC4yNS43NWgzNy41djE4Ny41aC0zNy41eiIvPjxwYXRoIGZpbGw9IiNGRUNCMDAiIGQ9Ik0uNSA3NS43NWgzMDB2MzcuNUguNXoiLz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/svg/flag/cif-se.svg
// module id = CW+D
// module chunks = 2